
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.917 6.667A6.674 6.674 0 017.583 0a6.674 6.674 0 016.667 6.667c0 2.928-4.167 10.021-5.957 12.935a.833.833 0 01-1.42 0C5.083 16.688.917 9.593.917 6.668zm3.75 0a2.917 2.917 0 105.833 0 2.917 2.917 0 00-5.833 0z","fill":"#35383D"}})])
          )
        }
      }
    